import { random } from "lodash";
import { _mock } from "./_mock";
import { createUrlFriendlyString } from "src/utils/string-functions";
import { generateDates } from "src/utils/global-functions";
import { _trainings } from "./_trainings";
import { _passes, _tickets } from "./_passestickets";
//const backgroundEventBackgrounColor1 = "#dbf6f8";
const backgroundEventBackgrounColor1 = "#98ff90b5";

const daysBeforeAndAfter = 4;

const venueBased = "venue-based";
const nonVenueBased = "non-venue-based";

const typeCoach = "coach";
const typeClub = "club";
const typeTournamentOrganiser = "tournament-organiser";
const randomId = Math.floor(Math.random() * 1000);
export const _sportProviders = [...Array(6)].map((_, index) => ({
  id: index, //_mock.id(index),
  providerTitle: typeClub,
  providerType: venueBased,
  name: _mock.fullName(index),
  city: _mock.fullAddress(index),
  //avatarUrl: "https://source.unsplash.com/random",
  avatarUrl: _mock.image.avatar(index),
  rating: _mock.number.rating(random(1, 5)),
  coverUrl: _mock.image.cover(index),
  profileUrl: _mock.companyName(index),
  urltag: createUrlFriendlyString(_mock.companyName(index)),
  settings: [],
  openhours: [
    "08:00-20:00",
    "08:00-20:00",
    "08:00-20:00",
    "08:00-20:00",
    "08:00-20:00",
    "10:00-22:00",
    "10:00-22:00",
  ],
  aimgroup:
    "Teniszezni vágyó anyukák számára nyújtunk pályafoglalási és edzési lehetőséget.",
  sports: [
    "tennis",
    "football",
    "padel",
    "tennis",
    "football",
    "padel",
    "tennis",
    "football",
    "padel",
  ],
  address: "4001 Debrecen Sár utca 5.",
  phone: "+36-1-333-444",
  maplink: "https://maps.google.com/",
  description:
    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. N",
  trainers: [
    { id: 1, name: "Edző bácsi 1", globalid: 1 },
    { id: 2, name: "Edző bá 2", globalid: 2 },
    { id: 3, name: "Edző néni 3", globalid: 3 },
  ],
  trainings: _trainings.slice(0, 3),
  // trainings: [
  //   {
  //     id: 3,
  //     name: "Haladó",
  //     period: { start: "2024-06-15", end: "2025-06-10" },
  //     days: { thursday: "12:00-14:30", friday: "10:00-12:30" },
  //     sport: "tennis",
  //     trainers: [2, 3],
  //   },
  //   {
  //     id: 1,
  //     name: "Kezdő",
  //     period: { start: "2024-06-15", end: "2025-06-10" },
  //     days: { monday: "08:00-09:30", tuesday: "10:00-12:30" },
  //     sport: "tennis",
  //     trainers: [],
  //   },
  //   {
  //     id: 2,
  //     name: "Profi",
  //     period: { start: "2024-07-15", end: "2024-10-10" },
  //     days: { wednesday: "12:00-14:30", friday: "10:00-12:30" },
  //     sport: "football",
  //     trainers: [1, 4],
  //   },
  // ],
  venues: [
    {
      id: 1,
      name: "1. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "1. Pálya",
      typeId: 1,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/tennis_court.jpg",
      type: {
        id: 5,
        name: "footballpitch",
        image: "",
        status: 1,
      },
    },

    {
      id: 3,
      name: "3. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "3. Pálya",
      typeId: 1,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/tennis_court.jpg",
      type: {
        id: 4,
        name: "indorroom",
        image: "",
        status: 1,
      },
    },
    {
      id: 4,
      name: "Nagypálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "Nagypálya",
      typeId: 2,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/football_court.jpg",
      type: {
        id: 3,
        name: "tennishall",
        image: "",
        status: 1,
      },
    },
    {
      id: 2,
      name: "2. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "2. Pálya",
      typeId: 1,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/tennis_court.jpg",
      type: {
        id: 5,
        name: "footballpitch",
        image: "",
        status: 1,
      },
    },
    {
      id: 5,
      name: "Kispálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "Kispálya",
      typeId: 2,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/football_court.jpg",
      type: {
        id: 5,
        name: "footballpitch",
        image: "",
        status: 1,
      },
    },

    {
      id: 6,
      name: "6. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "6. Pálya",
      typeId: 1,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/tennis_court.jpg",
      type: {
        id: 3,
        name: "tennishall",
        image: "",
        status: 1,
      },
    },
    {
      id: 7,
      name: "7. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "7. Pálya",
      typeId: 2,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/football_court.jpg",
      type: {
        id: 3,
        name: "tennishall",
        image: "",
        status: 1,
      },
    },

    {
      id: 8,
      name: "8. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "8. Pálya",
      typeId: 2,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/tennis_court.jpg",
      type: {
        id: 3,
        name: "tennishall",
        image: "",
        status: 1,
      },
    },
    {
      id: 9,
      name: "9. Pálya",
      providerId: randomId,
      shortName: "SC" + index,
      // title: "9. Pálya",
      typeId: 4,
      address: "",
      view: 1,
      status: 1,
      icon: "public/images/venues_icons/football_court.jpg",
      type: {
        id: 3,
        name: "tennishall",
        image: "",
        status: 1,
      },
    },
  ],
  venue_ids: [1, 3, 4],
  services: [
    {
      id: 1,
      name: "Napijegy",
      price: 2000,
    },
    { id: 2, name: "Ütőbérlés / alkalom", price: 1000 },
    { id: 3, name: "Szauna jegy", price: 3000 },
  ],
  tickets: _tickets,
  passes: _passes,
  // [
  //   {
  //     id: 1,
  //     name: "Fitnesz bérlet 31 napos",
  //     price: 20000,
  //   },
  //   { id: 2, name: "Jóga bérlet", price: 10000 },
  //   { id: 3, name: "Fél éves bérlet mindenre", price: 80000 },
  // ],

  bookings: [],
  gallery: [
    "/assets/images/hero_image_02.jpg",
    "/assets/images/hero_image01.jpg",
    "/assets/images/medal_first.png",
  ],
  timezone: "Europe/Budapest",
  currency: "HUF",
  rules: "Test rules",
  privacy_rules: "Test privacy rules",
  prices: "Test prices",
  modules: [
    "sportprovidermenu_profile",
    "sportprovidermenu_calendar",
    "sportprovidermenu_venues",
    "sportprovidermenu_results",
    "sportprovidermenu_events",
    "sportprovidermenu_trainings",

    "sportprovidermenu_camps",

    "sportprovidermenu_rankings",

    "sportprovidermenu_webshop",
    "sportprovidermenu_passes",
    "sportprovidermenu_services",
    "sportprovidermenu_tickets",
    "sportprovidermenu_livecalendar",

    "sportprovidermenu_rules",
    "sportprovidermenu_livestreaming",
    //"sportprovidermenu_prices",
  ],
  calendarslots: [
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T12:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b12",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[5] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T12:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b13",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[6] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T12:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b14",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[7] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T12:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b15",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[8] + "T07:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[8] + "T10:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b21",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T16:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b22",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[5] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T16:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b23",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[6] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T16:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b24",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[7] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T16:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b25",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[8] + "T10:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[8] + "T14:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b31",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T22:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b32",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[5] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T22:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b33",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[6] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T20:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b34",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[7] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T20:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b35",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[8] + "T14:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[8] + "T21:00:00+02:00",
      display: "background",
      resourceId: 1,
      type: "background",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent1",
      title: "Foglalt",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[5] + "T15:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T17:00:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent11",
      title: "Foglalt",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[5] + "T17:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T18:30:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent12",
      title: "Foglalt",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[5] + "T19:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T21:30:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent2",
      title: "Foglalt",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[6] + "T17:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T19:00:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent3",
      title: "Foglalt",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[6] + "T11:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T13:30:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent31",
      title: "Csőtörés miatt nem foglalható",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[6] + "T14:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T16:30:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent4",
      title: "Jóga csajoknak",
      allDay: false,
      color: "#72c5c7",
      description: " 6/10",
      start: generateDates(daysBeforeAndAfter)[7] + "T08:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T10:00:00+02:00",
      resourceId: 1,
      type: "training",
    },
    {
      id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent5",
      title: "Saját foglalás",
      allDay: false,
      color: "orange",
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T08:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T10:00:00+02:00",
      resourceId: 1,
      type: "booking",
    },

    /*------------------------2. Pálya-------------------------------*/
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T12:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b12",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[5] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T12:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b13",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[6] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T12:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b14",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[7] + "T06:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T12:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b15",
      title: "2500 USD/hour",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[8] + "T07:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[8] + "T10:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },

    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b21",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T16:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b22",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[5] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T16:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b23",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[6] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T16:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b24",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[7] + "T12:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T16:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b25",
      title: "3500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[8] + "T10:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[8] + "T14:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },

    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b31",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[4] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[4] + "T22:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b32",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[5] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T22:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b33",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[6] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T20:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b34",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[7] + "T16:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T20:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7b35",
      title: "4500 HUF/óra",
      allDay: false,
      color: backgroundEventBackgrounColor1,
      description: "",
      start: generateDates(daysBeforeAndAfter)[8] + "T14:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[8] + "T21:00:00+02:00",
      display: "background",
      resourceId: 2,
      type: "background",
    },
    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent3",
      title: "Foglalt",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[5] + "T12:45:00+02:00",
      end: generateDates(daysBeforeAndAfter)[5] + "T14:30:00+02:00",
      resourceId: 2,
      type: "booking",
    },

    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent31",
      title: "Karbantartás miatt lezárva",
      allDay: false,
      color: "#9a9a9a",
      description: "Hosszú Leírás, hogy mi is ez az időpont",
      start: generateDates(daysBeforeAndAfter)[6] + "T11:00:00+02:00",
      end: generateDates(daysBeforeAndAfter)[6] + "T12:30:00+02:00",
      resourceId: 2,
      type: "booking",
    },

    {
      id: "2e99f09a7-dd88-49d5-b1c8-1daf80c2d7bEvent4",
      title: "Terhes torna",
      allDay: false,
      color: "#72c5c7",
      description: "3/10",
      start: generateDates(daysBeforeAndAfter)[7] + "T09:30:00+02:00",
      end: generateDates(daysBeforeAndAfter)[7] + "T10:40:00+02:00",
      resourceId: 2,
      type: "training",
    },
  ],
}));
